import { makeAutoObservable } from "mobx";
import { SearchEmployeeStatus } from "app/common/Model/SearchObject";
import { deleteEmployeeStatus, getEmployeeStatusById, searchByPageEmployeeStatus, saveOrUpdateEmployeeStatus, saveEmployeeStatusSyncEmployeeStatusHRM } from "app/services/ServiceEmployeeStatus";
import { toast } from "react-toastify";
import { EmployeeStatusType } from "app/common/Model/EmployeeStatus";

export default class EmployeeStatusStore {
    openEmployeeStatusCreateOrUpdate = false;
    searchEmployeeStatus = new SearchEmployeeStatus();
    pageEmployeeStatus = null;
    selectedEmployeeStatus = new EmployeeStatusType();
    openConfirmDeleteEmployeeStatus = false;
    openSyncEmployeeStatusHRM = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingEmployeeStatus = async () => {
        return await searchByPageEmployeeStatus(this.searchEmployeeStatus)
            .then(({ data }) => {
                this.pageEmployeeStatus = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu trạng thái nhân viên có lỗi");
            });
    };

    handleOpenFormCreateOrEdit = (employeeStatusId) => {
        if (employeeStatusId) {
            getEmployeeStatusById(employeeStatusId)
                .then(({ data }) => {
                    this.selectedEmployeeStatus = data;
                    this.openEmployeeStatusCreateOrUpdate = true;
                })
                .catch((error) => {
                    toast.error("Lấy dữ liệu trạng thái nhân viên có lỗi");
                    console.error("Lỗi lấy dữ liệu trạng thái nhân viên:", error);
                });
        } else {
            this.selectedEmployeeStatus = new EmployeeStatusType();
            this.openEmployeeStatusCreateOrUpdate = true;
        }
    };

    handleCreateOrEdit = async (employeeStatusData) => {
        try {
            //console.log("Dữ liệu gửi đi:", employeeStatusData);
            const { data } = await saveOrUpdateEmployeeStatus(employeeStatusData);
            toast.success("Lưu EmployeeStatus thành công!");
            this.handleClosePopup();
            await this.pagingEmployeeStatus();
            return data;
        } catch (error) {
            toast.error("Lưu trạng thái nhân viên thất bại!");
            console.error("Lưu trạng thái nhân viên thất bại!:", error);
        }
    };

    handleDelete = async () => {
        const employeeStatusId = this.selectedEmployeeStatus?.id;
        if (!employeeStatusId) return;

        deleteEmployeeStatus(employeeStatusId)
            .then(() => {
                // Nếu đang ở trang > 1 và chỉ còn 1 dòng dữ liệu, thì lùi về trang trước
                if (
                    this.searchEmployeeStatus?.pageIndex > 1 &&
                    this.pageEmployeeStatus?.content?.length === 1
                ) {
                    this.searchEmployeeStatus.pageIndex -= 1;
                }
                toast.success("Xóa trạng thái nhân viên thành công!");
                this.pagingEmployeeStatus();
                this.handleClosePopup();
            })
            .catch((error) => {
                console.error("Lỗi khi xóa trạng thái nhân viên:", error);
                toast.error("Xóa trạng thái nhân viên thất bại!");
            });
    };

    handleChangeFormSearch = (searchEmployeeStatus) => {
        this.searchEmployeeStatus = {
            ...this.searchEmployeeStatus,
            ...searchEmployeeStatus,
        };
        this.pagingEmployeeStatus();
    };

    handleDeleteEmployeeStatus = (employeeStatus) => {
        this.selectedEmployeeStatus = employeeStatus;
        this.openConfirmDeleteEmployeeStatus = true;
    };

    handleClosePopup = () => {
        this.openEmployeeStatusCreateOrUpdate = false;
        this.openConfirmDeleteEmployeeStatus = false;
    };

    handleOpenSyncEmployeeStatusHRM = () => {
        this.openSyncEmployeeStatusHRM = true
    }

    handleCloseSyncEmployeeStatusHRM = () => {
        this.openSyncEmployeeStatusHRM = false
    }

    handleSaveSyncEmployeeStatusHRM = (data, { setSubmitting }) => {
        saveEmployeeStatusSyncEmployeeStatusHRM(data).then(() => {
            this.openSyncEmployeeStatusHRM = false;
            toast.success("Đồng bộ trạng thái nhân viên thành công")
            this.pagingEmployeeStatus();
        }).catch((err) => {
            toast.error("Đồng bộ trạng thái nhân viên thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    resetStore = () => {
        this.searchEmployeeStatus = new SearchEmployeeStatus();
        this.pageEmployeeStatus = null;
        this.selectedEmployeeStatus = new EmployeeStatusType();
        this.openEmployeeStatusCreateOrUpdate = false;
    };
}
